<template>
  <div>
    <el-dialog width="30%" title="Ghi chú" v-if="visibleDialog" :visible.sync="visibleDialog" destroy-on-close>
      <el-input type="textarea" :rows="3" v-model="customerInfo.note" resize="none"></el-input>
      <div class="d-flex justify-content-end mt-2">
        <div class="mx-4">

          <el-popover v-if="customerInfo.notes.length > 0" placement="bottom" trigger="click">
            <el-table height="300" style="width: 550px" :data="customerInfo.notes">
              <el-table-column prop="note" label="Ghi chú" width="300">
                <template slot-scope="scope" v-if="scope.row">
                  <div style="white-space: pre-line" class="text-normal">
                    {{ scope.row.note }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column prop="createdBy" label="Người tạo">
              </el-table-column>
              <el-table-column prop="createAt" label="Thời gian">
                <template slot-scope="scope">
                  <span>{{ convertTime(scope.row.createAt) }}</span>
                </template>
              </el-table-column>
            </el-table>

            <el-button slot="reference" type="text" v-if="customerInfo.notes.length > 0"><i
              class="el-icon-time me-1"></i> Lịch sử
            </el-button>
          </el-popover>
        </div>
        <el-button type="primary" icon="el-icon-folder" size="small" @click="save">Lưu</el-button>

      </div>
    </el-dialog>
    <div class="pointer" @click="showDialog()"><i class="icon-order font-size-22 text-secondary" /></div>
  </div>

</template>

<script>
export default {
  name: "NoteGroup",
  props: ["IdConversationGroup"],
  data() {
    return {
      visibleDialog: false,
      customerInfo: {
        note: "",
        notes: []
      },
      historyNoteVisible: false
    };
  },
  methods: {

    setDefaultValue() {
      this.customerInfo = {
        note: "",
        notes: []
      };
    },
    showDialog() {
      this.visibleDialog = true;
    },
    save() {
      if (this.customerInfo.note.trim().length === 0) return this.alert("error", "Vui lòng nhập vào ghi chú");
      let body = {
        conversationId: this.IdConversationGroup.id,
        accountId: this.IdConversationGroup.accountId,
        toId: this.IdConversationGroup.toId,
        note: this.customerInfo.note
      };

      this.$http.post("/api/customer-info", body)
        .then((resp) => {
          this.alert("success", "Cập nhật thành công.");
          this.customerInfo.notes = resp.data.notes;
          this.updateModel(resp.data);
        })
        .catch((ex) => {
          this.alert("error", ex.error ? ex.error.message : "Có lỗi xảy ra.");
        });
    },
    getNotes() {
      let request = {
        params: {
          accountId: this.IdConversationGroup.accountId,
          toId: this.IdConversationGroup.toId,
          conversationId: this.IdConversationGroup.id
        }
      };

      this.$http.get("/api/customer-info", request)
        .then((resp) => {
          this.customerInfo.notes = resp.data.notes;
          let info = resp.data;
          this.updateModel(info);
        })
        .catch((ex) => {
          this.alert("error", ex.error ? ex.error.message : "Có lỗi xảy ra1.");
        });
    },
    updateModel(info) {
      if (info.id) {
        this.customerInfo.notes = info.notes;
        if (this.customerInfo.notes.length > 0) {
          this.customerInfo.notes.sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
          this.customerInfo.note=this.customerInfo.notes[0].note;
        } else {
          this.customerInfo.note = "";
        }
      } else {
        this.setDefaultValue();
      }
    }
  },
  created() {
    this.getNotes();
  }
};
</script>

<style scoped>

</style>